module.exports = __webpack_public_path__ + "static/media/PCP Ingredient.82950ffa.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/cont/PCP Ingredient.png
// module id = 1186
// module chunks = 0